import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Act } from '../model/recital';

export interface GetAllActsParams {
  showId: string;
}

export const getAllActsAPI = async ({ showId }: GetAllActsParams) => {
  const response = await baseAPI.get<Act[]>(`/shows/${showId}/acts`);
  return response.data;
};

export const getAllActsOptions = (params: GetAllActsParams) => {
  return queryOptions({
    queryKey: [KEYS.SHOWS, params.showId, KEYS.ACTS],
    queryFn: () => getAllActsAPI(params),
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetAllActs = (params: GetAllActsParams) => {
  return useQuery(getAllActsOptions(params));
};
